import { formatTimestamp } from "../utils/timestamps.mjs";
import React from "react";
import { reactivationClients } from "../services/commercial.mjs";
import { formatDate, todayParis } from "../crm.mjs";
import { Panel, Empty } from "../components/ui";
export default function Reactivation({ state, onClient }) {
  const today = todayParis();
  const clients = reactivationClients(state, today);
  return (
    <>
      <Panel title="Réactivation des clients">
        <p className="hint">Clients sans commande depuis au moins 30 jours, ou signalés à réactiver, dormants, perdus ou à risque.</p>
      </Panel>
      {clients.length > 0 && (
        <Panel title="Clients à réactiver">
          <div className="tableScroll">
            <table className="taskTable reactivationList">
              <thead><tr><th>Client</th><th>Statut</th><th>Situation</th><th>Priorité</th><th>Action</th></tr></thead>
              <tbody>
                {clients.map(({ client: c, inactivity, reasons }) => (
                  <tr key={c.id}>
                    <td><b>{c.name}</b><small>{c.city}</small></td>
                    <td><span className="status">{c.status}</span></td>
                    <td>{inactivity && <span>{`Dernière commande : ${formatDate(inactivity.lastOrder)} · ${inactivity.days} jours sans commande`}</span>}{reasons.length > 0 && <span>{reasons.join(" · ")}</span>}{c.lossReason && <small>{formatTimestamp(c.lossReasonAt)}</small>}</td>
                    <td><b>{Number(c.score || 0)}/100</b></td>
                    <td><button className="tableAction" onClick={() => onClient(c.id)}>Saisir le résultat de mon appel</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Panel>
      )}
      {!clients.length && <Empty>Aucun établissement à réactiver pour le moment.</Empty>}
    </>
  );
}
